import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_QUERY_TEMPLATES = 'GET_QUERY_TEMPLATES';
export const GET_QUERY_TEMPLATE = 'GET_QUERY_TEMPLATE';
export const CREATE_QUERY_TEMPLATE = 'CREATE_QUERY_TEMPLATE';
export const UPDATE_QUERY_TEMPLATE = 'UPDATE_QUERY_TEMPLATE';
export const DELETE_QUERY_TEMPLATES = 'DELETE_QUERY_TEMPLATES';
export const SET_CURRENT_QUERY_TEMPLATE = 'SET_CURRENT_QUERY_TEMPLATE';
export const UNSET_CURRENT_QUERY_TEMPLATE = 'UNSET_CURRENT_QUERY_TEMPLATE';
export const CLEAR_QUERY_TEMPLATE_ERROR = 'CLEAR_QUERY_TEMPLATE_ERROR';

export const CLEAR_QUERY_TEMPLATE_STORE = 'CLEAR_QUERY_TEMPLATE_STORE';

export const WARN_AND_ARCHIVE_QUERY_TEMPLATE =
  'WARN_AND_ARCHIVE_QUERY_TEMPLATE';

export const GET_PAGINATED_QUERY_TEMPLATES = 'GET_PAGINATED_QUERY_TEMPLATES';
export const GET_MINIMAL_QUERY_TEMPLATES = 'GET_MINIMAL_QUERY_TEMPLATES';

// async actions
export const GETTING_QUERY_TEMPLATES = 'GETTING_QUERY_TEMPLATES';
export const GETTING_QUERY_TEMPLATES_SUCCEEDED =
  'GETTING_QUERY_TEMPLATES_SUCCEEDED';
export const GETTING_QUERY_TEMPLATES_FAILED = 'GETTING_QUERY_TEMPLATES_FAILED';

export const GETTING_QUERY_TEMPLATE = 'GETTING_QUERY_TEMPLATE';
export const GETTING_QUERY_TEMPLATE_FAILED = 'GETTING_QUERY_TEMPLATE_FAILED';
export const GETTING_QUERY_TEMPLATE_SUCCEEDED =
  'GETTING_QUERY_TEMPLATE_SUCCEEDED';

export const CREATING_QUERY_TEMPLATE = 'CREATING_QUERY_TEMPLATE';
export const CREATING_QUERY_TEMPLATE_SUCCEEDED =
  'CREATING_QUERY_TEMPLATE_SUCCEEDED';
export const CREATING_QUERY_TEMPLATE_FAILED = 'CREATING_QUERY_TEMPLATE_FAILED';

export const UPDATING_QUERY_TEMPLATE = 'UPDATING_QUERY_TEMPLATE';
export const UPDATING_QUERY_TEMPLATE_SUCCEEDED =
  'UPDATING_QUERY_TEMPLATE_SUCCEEDED';
export const UPDATING_QUERY_TEMPLATE_FAILED = 'UPDATING_QUERY_TEMPLATE_FAILED';

export const DELETING_QUERY_TEMPLATES = 'DELETING_QUERY_TEMPLATES';
export const DELETING_QUERY_TEMPLATES_SUCCEEDED =
  'DELETING_QUERY_TEMPLATES_SUCCEEDED';
export const DELETING_QUERY_TEMPLATES_FAILED =
  'DELETING_QUERY_TEMPLATES_FAILED';

export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_SUCCEEDED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_SUCCEEDED';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED';

export const GET_RECIPIENT_DETAILS = 'GET_RECIPIENT_DETAILS';
export const GETTING_RECIPIENT_DETAILS_SUCCEEDED =
  'GETTING_RECIPIENT_DETAILS_SUCCEEDED';
export const GETTING_RECIPIENT_DETAILS_FAILED =
  'GETTING_RECIPIENT_DETAILS_FAILED';

export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const UNSET_NEXT_STEP = 'UNSET_NEXT_STEP';

export const GETTING_PAGINATED_QUERY_TEMPLATES =
  'GETTING_PAGINATED_QUERY_TEMPLATES';
export const GETTING_PAGINATED_QUERY_TEMPLATES_SUCCEEDED =
  'GETTING_PAGINATED_QUERY_TEMPLATES_SUCCEEDED';
export const GETTING_PAGINATED_QUERY_TEMPLATES_FAILED =
  'GETTING_PAGINATED_QUERY_TEMPLATES_FAILED';

export const GETTING_MINIMAL_QUERY_TEMPLATES = 'GETTING_MINIMAL_QUERY_TEMPLATES';
export const GETTING_MINIMAL_QUERY_TEMPLATES_SUCCEEDED =
  'GETTING_MINIMAL_QUERY_TEMPLATES_SUCCEEDED';
export const GETTING_MINIMAL_QUERY_TEMPLATES_FAILED =
  'GETTING_MINIMAL_QUERY_TEMPLATES_FAILED';

export const SET_COPY_CURRENT_QUERY_TEMPLATE =
  'SET_COPY_CURRENT_QUERY_TEMPLATE';

export const GET_RECIPIENT_COUNT_REQUEST_ID = 'GET_RECIPIENT_COUNT_REQUEST_ID';
export const GETTING_RECIPIENT_COUNT_REQUEST_ID_SUCCEEDED =
  'GETTING_RECIPIENT_COUNT_REQUEST_ID_SUCCEEDED';
export const GETTING_RECIPIENT_COUNT_REQUEST_ID_FAILED =
  'GETTING_RECIPIENT_COUNT_REQUEST_ID_FAILED';
export const GET_LISTS_RECIPIENT_COUNT = 'GET_LISTS_RECIPIENT_COUNT';
export const GETTING_LISTS_RECIPIENT_COUNT_SUCCEEDED =
  'GETTING_LISTS_RECIPIENT_COUNT_SUCCEEDED';
export const GETTING_LISTS_RECIPIENT_COUNT_FAILED =
  'GETTING_LISTS_RECIPIENT_COUNT_FAILED';
export const START_POLLING = 'START_POLLING';
export const END_POLLING = 'END_POLLING';
export const RESET_LIST_RECIPIENT_COUNT = 'RESET_LIST_RECIPIENT_COUNT';

export const UPDATE_RECIPIENT_QUERY_FILTERS = 'UPDATE_RECIPIENT_QUERY_FILTERS';
export const RESET_RECIPIENT_QUERY_FILTERS = 'RESET_RECIPIENT_QUERY_FILTERS';

export const getQueryTemplates = createAction(GET_QUERY_TEMPLATES);

export const getQueryTemplate = createAction(GET_QUERY_TEMPLATE);

export const createQueryTemplate = createAction(CREATE_QUERY_TEMPLATE);

export const updateQueryTemplate = createAction(UPDATE_QUERY_TEMPLATE);

export const deleteQueryTemplates = createAction(DELETE_QUERY_TEMPLATES);

export const warnAndArchiveQueryTemplate = createAction(
  WARN_AND_ARCHIVE_QUERY_TEMPLATE
);

export const setCurrentQueryTemplate = createAction(SET_CURRENT_QUERY_TEMPLATE);

export const unsetCurrentQueryTemplate = createAction(
  UNSET_CURRENT_QUERY_TEMPLATE
);

export const clearTemplateQueryError = createAction(CLEAR_QUERY_TEMPLATE_ERROR);

export const clearQueryTemplateStore = createAction(CLEAR_QUERY_TEMPLATE_STORE);

export const gettingQueryTemplates = createAction(GETTING_QUERY_TEMPLATES);

export const gettingQueryTemplatesSucceeded = createAction(
  GETTING_QUERY_TEMPLATES_SUCCEEDED
);

export const gettingQueryTemplatesFailed = createAction(
  GETTING_QUERY_TEMPLATES_FAILED
);

export const gettingQueryTemplate = createAction(GETTING_QUERY_TEMPLATE);

export const gettingQueryTemplateSucceeded = createAction(
  GETTING_QUERY_TEMPLATE_SUCCEEDED
);

export const gettingQueryTemplateFailed = createAction(
  GETTING_QUERY_TEMPLATE_FAILED
);

export const creatingQueryTemplate = createAction(CREATING_QUERY_TEMPLATE);

export const creatingQueryTemplateSucceeded = createAction(
  CREATING_QUERY_TEMPLATE_SUCCEEDED
);

export const creatingQueryTemplateFailed = createAction(
  CREATING_QUERY_TEMPLATE_FAILED
);

export const updatingQueryTemplate = createAction(UPDATING_QUERY_TEMPLATE);

export const updatingQueryTemplateSucceeded = createAction(
  UPDATING_QUERY_TEMPLATE_SUCCEEDED
);

export const updatingQueryTemplateFailed = createAction(
  UPDATING_QUERY_TEMPLATE_FAILED
);

export const deletingQueryTemplates = createAction(DELETING_QUERY_TEMPLATES);

export const deletingQueryTemplatesSucceeded = createAction(
  DELETING_QUERY_TEMPLATES_SUCCEEDED
);

export const deletingQueryTemplatesFailed = createAction(
  DELETING_QUERY_TEMPLATES_FAILED
);

export const gettingAssociatedCampaignsForQueryTemplate = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE
);

export const gettingAssociatedCampaignsForQueryTemplateSucceeded = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_SUCCEEDED
);

export const gettingAssociatedCampaignsForQueryTemplateFailed = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED
);

export const getRecipientDetails = createAction(GET_RECIPIENT_DETAILS);
export const gettingRecipientDetailsSucceeded = createAction(
  GETTING_RECIPIENT_DETAILS_SUCCEEDED
);
export const gettingRecipientDetailsFailed = createAction(
  GETTING_RECIPIENT_DETAILS_FAILED
);

export const getRecipientCountRequestId = createAction(
  GET_RECIPIENT_COUNT_REQUEST_ID
);
export const gettingRecipientCountRequestIdSucceeded = createAction(
  GETTING_RECIPIENT_COUNT_REQUEST_ID_SUCCEEDED
);
export const gettingRecipientCountRequestIdFailed = createAction(
  GETTING_RECIPIENT_COUNT_REQUEST_ID_FAILED
);
export const getListsRecipientCount = createAction(GET_LISTS_RECIPIENT_COUNT);
export const gettingListsRecipientCountSucceeded = createAction(
  GETTING_LISTS_RECIPIENT_COUNT_SUCCEEDED
);
export const gettingListsRecipientCountFailed = createAction(
  GETTING_LISTS_RECIPIENT_COUNT_FAILED
);
export const startPolling = createAction(START_POLLING);
export const endPolling = createAction(END_POLLING);
export const resetListRecipientCount = createAction(RESET_LIST_RECIPIENT_COUNT);

export const setNextStep = createAction(SET_NEXT_STEP);

export const unsetNextStep = createAction(UNSET_NEXT_STEP);

export const getPaginatedQueryTemplates = createAction(
  GET_PAGINATED_QUERY_TEMPLATES
);

export const getMinimalQueryTemplates = createAction(GET_MINIMAL_QUERY_TEMPLATES);

export const gettingPaginatedQueryTemplates = createAction(
  GETTING_PAGINATED_QUERY_TEMPLATES
);
export const gettingPaginatedQueryTemplatesSucceeded = createAction(
  GETTING_PAGINATED_QUERY_TEMPLATES_SUCCEEDED
);
export const gettingPaginatedQueryTemplatesFailed = createAction(
  GETTING_PAGINATED_QUERY_TEMPLATES_FAILED
);

export const gettingMinimalQueryTemplates = createAction(GETTING_MINIMAL_QUERY_TEMPLATES);
export const gettingMinimalQueryTemplatesSucceeded = createAction(
  GETTING_MINIMAL_QUERY_TEMPLATES_SUCCEEDED
);
export const gettingMinimalQueryTemplatesFailed = createAction(
  GETTING_MINIMAL_QUERY_TEMPLATES_FAILED
);

export const setCopyCurrentQueryTemplate = createAction(
  SET_COPY_CURRENT_QUERY_TEMPLATE
);

export const updateRecipientQueryFilters = createAction(
  UPDATE_RECIPIENT_QUERY_FILTERS
);

export const resetRecipientQueryFilters = createAction(
  RESET_RECIPIENT_QUERY_FILTERS
);